import { useEffect } from 'react';
import Bugsnag from '@bugsnag/js';
import { useIsExperimentActivated } from '@99designs/experiments';
import { usePrintSupportedCategoriesQuery } from './printSupportedCategories.generated';

export function useCheckPrintSupported(category: string | undefined, locale: string) {
    const labsExperimentEnabled = useIsExperimentActivated('labs', 'enabled');
    const { data, error } = usePrintSupportedCategoriesQuery();

    useEffect(() => {
        if (error) {
            Bugsnag.notify(error, (event) => {
                event.context = 'Getting supported categories from product list';
            });
        }
    }, [error]);

    return data?.supportedCategories.some(
        (product) =>
            product.categoryKey === category &&
            product.locale.toLowerCase() === locale.toLowerCase() &&
            (labsExperimentEnabled || !product.isExperimental)
    );
}
